<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="编码/名称">
              <a-input v-model.trim="queryParam.codeAndName" placeholder=""/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
           <!-- <a-col :md="4" :sm="24">
              <a-form-item label="是否免审">
                <a-select v-model="queryParam.fromAudit" placeholder="请选择" >
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->

            <a-col :md="6" :sm="24">
              <a-form-item label="业务员">
                <a-input v-model.trim="queryParam.username" placeholder=""/>
              </a-form-item>
            </a-col>

         <!--    <a-col :md="4" :sm="24">
              <a-form-item label="等级">
                <a-select v-model="queryParam.level" placeholder="请选择" >
                  <a-select-option value="A">A</a-select-option>
                  <a-select-option value="B">B</a-select-option>
                  <a-select-option value="C">C</a-select-option>
                  <a-select-option value="D">D</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="区域编号">
                <a-input-number v-model="queryParam.areaOneAndTwoCode" style="width: 100%"/>
              </a-form-item>
            </a-col> -->

         <!--    <a-col :md="8" :sm="24">
              <a-form-item label="起止日期"
                           :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                           :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
                <a-range-picker v-model="queryParam.createTime" style="width: 100%"
                                showTime format="YYYY-MM-DD"/>
              </a-form-item>
            </a-col>
 -->

          </template>

          <a-col :md="!advanced && 4 || 4" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
           <!--    <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator" >

      <a-button type="primary" icon="plus" @click="handleAdd()" v-if="rolelimitwhbi">新建</a-button>

      <a-upload
        accept=".xls,.xlsx"
        :showUploadList="false"
        :action= "config.importBusinessUrl"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      v-if="rolelimitwhbi">
        <a-button style="margin-left: 8px" type="primary" icon="plus" v-if="rolelimitwhbi">导入</a-button>
      </a-upload>
      <a-button style="margin-left: 8px" type="primary" @click="downLoad()" v-if="rolelimitwhbi">模板下载</a-button>
      <a-button style="margin-left: 8px" type="primary" @click="handleExport()" v-if="rolelimitwhbi">导出</a-button>
      <a-button style="margin-left: 8px" type="primary" @click="OneclickExemption()" v-if="rolelimitwhbd">一键免审</a-button>
    </div>

    <s-table
      ref="table"
      size="small"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 2700 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
      <span class="blacktr" v-if="blackListOpen && $store.getters.blackList['2'] && $store.getters.blackList['2'][record.id]">
      </span>
    </span>

     <!-- <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a v-if="blackListOpen && (!$store.getters.blackList['2'] || !$store.getters.blackList['2'][record.id])"
                                  @click="handleBlack(record)">拉黑</a>
        <span v-else>已黑</span>
         <a-dropdown>
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item><a @click="handleAccredit(record)">拉黑</a></a-menu-item>
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>-->


      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)" v-if="rolelimitwhbi">编辑  </a>
          <a-divider type="vertical" v-if='roleId === config.RoleType.FINANCE'/>
        <a @click="doReceipt(record)" v-if='roleId === 21 || rolelimit == true ' >  收款</a>
        <a-divider type="vertical" v-if='rolelimitwhbi'/>
        <a-dropdown v-if="rolelimitwhbi">
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
          <!--  <a-menu-item v-if="blackListOpen">
            <a v-if="blackListOpen && (!$store.getters.blackList['2'] || !$store.getters.blackList['2'][record.id])" @click="handleBlack(record)">拉黑</a>
            <span v-else>已黑</span></a-menu-item>-->
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal title="操作" style="top: 10px;" :width="800" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="客户名称" v-decorator="['name', { initialValue: mdl.name, rules: [{ required: true, message: '请输入客户名称'}]}]"/>
        </a-form-item>

        <a-form-item label="编码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="客户编码" v-model="mdl.code" v-decorator="['code', { initialValue: mdl.code, rules: [{ required: true, message: '请输入客户编码'}]}]"/>
        </a-form-item>

        <a-form-item label="营业执照号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="营业执照号" v-model="mdl.businessLicenseNo" v-decorator="['businessLicenseNo', { initialValue: mdl.businessLicenseNo, rules: [{ required: true, message: '请输入营业执照号'}]}]"/>
        </a-form-item>

        <a-form-item label="有效期" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
           <a-date-picker
                  format="YYYY-MM-DD"
                  v-model="mdl.validPeriod"
                  placeholder="有效期"
                  style="width:380px"
                  v-decorator="['validPeriod', { initialValue: mdl.validPeriod, rules: [{ required: true, message: '请输入有效期'}]}]"
                />
        </a-form-item>

          <a-form-item
        label="是否免审"
        validateStatus="warning"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        v-if="rolelimitwhbd"
      >
        <a-select v-model="mdl.fromAudit" v-decorator="['fromAudit', { initialValue: mdl.fromAudit, rules: [{ required: true, message: '请选择是否免审'}]}]">
          <a-select-option value="1">是</a-select-option>
          <a-select-option value="0">否</a-select-option>
        </a-select>
      </a-form-item>

        <a-form-item label="合同号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="合同号" v-model="mdl.contractno"/>
        </a-form-item>

        <a-form-item label="等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" v-if="rolelimitwhbl">
          <a-select v-model="mdl.level"  placeholder="请选择" v-decorator="['level', { initialValue: mdl.level, rules: [{ required: true, message: '请选择客户等级'}]}]" >
            <a-select-option v-for="(item, index) in levelSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="客户联系人" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="客户联系人" v-model="mdl.linkMan"/>
        </a-form-item>

        <a-form-item
          label="联系人电话"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="联系人电话" v-model="mdl.linkManPhone" v-decorator="['linkManPhone', { initialValue: mdl.linkManPhone, rules: [{ required: false,max:11, message: '请输入正确格式长度手机号码'}]}]" @blur="validatePhoneBlur"/>
        </a-form-item>

        <!--<a-form-item
          label="手机号"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="手机号" v-model="mdl.phone" v-decorator="['phone', { initialValue: mdl.phone, rules: [{ required: true,max:11, message: '请输入正确格式长度手机号码'}]}]" />
        </a-form-item>-->

        <a-form-item label="业务员" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-select :filterOption="filterOption" v-model="mdl.userId" placeholder="请选择">
            <a-select-option v-for="(item, index) in userSelect" :key="index" :value="item.id">{{ item.username }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="所属区域1" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="所属区域1" v-model="mdl.areaOne" />
        </a-form-item>

        <a-form-item label="所属区域2":label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="所属区域2" v-model="mdl.areaTwo" />
        </a-form-item>

        <a-form-item label="所属区域3":label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="所属区域3" v-model="mdl.areaThree" />
        </a-form-item>

        <a-form-item label="区域编码1":label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="区域编码1" v-model="mdl.areaOneCode" />
        </a-form-item>

        <a-form-item label="区域编码2" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="区域编码2" v-model="mdl.areaTwoCode" />
        </a-form-item>

        <a-form-item label="区域编码3" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="区域编码3" v-model="mdl.areaThreeCode" />
        </a-form-item>


      </a-form>
    </a-modal>

    <a-modal
      title="拉黑"
      :width="640"
      v-model="blackModel" @ok="handleBlackOk"
      :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="企业名" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-input disabled placeholder="企业名" v-model="black.name" id="role_name" />
        </a-form-item>

        <a-form-item label="类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-select disabled v-model="black.type" placeholder="请选择" >
            <a-select-option v-for="(item, index) in typeSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="拉黑原因" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-textarea :rows="1" v-model="black.remark" placeholder="..." id="describe"
            v-decorator="['remark',
            { initialValue: black.remark, rules: [{ required: true, message: '请输入拉黑原因'}]}]"/>
        </a-form-item>
      </a-form>
    </a-modal>

     <!-- 回款单添加和修改 -->
     <a-modal title="操作" :maskClosable="config.globlaMaskClosable" style="top: 10px;" :width="640" :confirmLoading="showLoading" v-model="receiptVisible"
        @ok="saveReceipt" destroyOnClose>
        <a-form :form="receiptForm">
          <a-form-item label="客户名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input disabled  v-model="receiptMdl.businessName"  />
          </a-form-item>


          <a-form-item label="收款类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">

                <a-select v-model="receiptMdl.receiptType" placeholder="请选择" :defaultValue="收款"
               v-decorator="['receiptType', { initialValue: receiptMdl.receiptType, rules: [{ required: true, message: '请输入收款类型'}]}]"
                 >
                  <a-select-option value="收款" v-if="roleId === 21">收款</a-select-option>
                  <a-select-option value="授信" v-if="rolelimit == true">授信</a-select-option>

                </a-select>

          </a-form-item>


          <a-form-item label="收款时间" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-date-picker :disabledDate="disabledDate" style="width: 297px"
              v-decorator="['receiptTime', { initialValue: receiptMdl.receiptTime, rules: [{ required: true, message: '请输入收款时间'}]}]"
              placeholder="收款时间" />
          </a-form-item>

          <a-form-item label="收款金额" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input-number :min="-10000000000" :max="10000000000" :precision="precision" style="width: 296px;"
              v-decorator="['receiptAmount', { initialValue: receiptMdl.receiptAmount, rules: [{ required: true, message: '请输入收款金额'}]}]" />
          </a-form-item>
          <a-form-item label="备注" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input  v-decorator="['memo', { initialValue: receiptMdl.memo, rules: [{ required: false, message: '请输入备注'}]}]" />
          </a-form-item>
        </a-form>
      </a-modal>



  </a-card>
</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { STable } from '@/components'
  import { corpBusinessDelete, corpBusinessPage, corpBusinessSave, corpBusinessUpdate ,corpBusinessSyncData,updateFromAudit} from '@/api/basic'
  import { blackListSave,corpBusinessExport } from '@/api/basic'
  import { userList, findPrivileBycode } from '@/api/sys'
  import { formatDate } from '@/utils/date'
  import Bus from '@/layouts/bus'
  import config from '@/config/defaultSettings'
  import moment from 'moment'
  import { formatCurrency } from '@/utils/util'
  import { saveReceipt } from '@/api/order'

  export default {
    name: 'CorpBusiness',
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList:['10'],
        visible: false,
        confirmLoading: false,
        blackModel: false,
        form: this.$form.createForm(this),
        mdl: {},
        black: {},
        blackListOpen: config.blackListOpen,

        // 高级搜索 展开/关闭
        advanced: true,
        // 查询参数
        queryParam: {},
        loading:false,
        roleId: null,
        receiptMdl: {},
        rolelimit: false,
        rolelimitwhbi: false,
        rolelimitwhbl: false,
        rolelimitwhbd: false,
        receiptForm: this.$form.createForm(this),
        receiptVisible:false,
        defaultAmount: 0,
        defaultDate: moment(new Date(), 'YYYY-MM-DD'),
        precision:2,
        showLoading: false,

        // 表头
        columns: [
          {
            title: '#',
            scopedSlots: { customRender: 'serial' },
            width: '40px',
            fixed: 'left'
          },
          {
            title: '名称',
            dataIndex: 'name',
            fixed: 'left',
            width: '340px',
          },
          {
            title: '编码',
            dataIndex: 'code',
            width: '180px',
          },
           {
            title: '营业执照号',
            dataIndex: 'businessLicenseNo',
            width: '180px',
          },
           {
            title: '有效期',
            dataIndex: 'validPeriod',
            width: '180px',
             customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
          },
           {
            title: '合同',
            dataIndex: 'contractno',
            width: '180px',
          },
          {
            title: '授信额度',
            dataIndex: 'creditLimit',
            width: '120px',
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
           {
            title: '已使用授信额度',
            dataIndex: 'useCreditLimit',
            width: '120px',
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
           {
            title: '剩余授信额度',
            dataIndex: 'remainCreditLimit',
            width: '120px',
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
          {
            title: '充值总金额',
            dataIndex: 'rechargeAmount',
            width: '120px',
            sorter: true,
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
          {
            title: '剩余金额',
            dataIndex: 'remainAmount',
            width: '100px',
            sorter: true,
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
          {
            title: '预约锁定余额',
            dataIndex: 'lockmoney',
            width: '100px',
            sorter: true,
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
          {
            title: '可用余额',
            dataIndex: 'canusemoney',
            width: '100px',
            sorter: true,
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
          {
            title: '等级',
            dataIndex: 'level',
            width: '100px',
             customRender: (text, record) => {
               if(text=='1'){
                     return 'A'
               }else if(text=='2'){
                     return 'B'
               }else if(text=='3'){
                     return 'C'
               }else if(text=='4'){
                     return 'D'
               }

            }
          },
          {
            title: '客户联系人',
            dataIndex: 'linkMan',
            width: '100px',
          },
          {
            title: '联系人电话',
            dataIndex: 'linkManPhone',
            width: '120px',
          },
          {
            title: '业务员',
            dataIndex: 'userId',
            width: '100px',
            customRender: (text, record) => {
              return this.getUserNameById(text)
            }
          },
          {
            title: '所属区域1',
            dataIndex: 'areaOne',
            width: '150px',
          },
          {
            title: '所属区域2',
            dataIndex: 'areaTwo',
            width: '150px',
          },
           {
            title: '所属区域3',
            dataIndex: 'areaThree',
            width: '150px',
          },
          {
            title: '区域编码1',
            dataIndex: 'areaOneCode',
            width: '150px',
          },
          {
            title: '区域编码2',
            dataIndex: 'areaTwoCode',
            width: '150px',
          },
           {
            title: '区域编码3',
            dataIndex: 'areaThreeCode',
            width: '150px',
          },
           {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '160px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '160px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
          {
            title: '操作',
            width: '200px',
            fixed: 'right',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 所属菜单下拉
        userSelect: null,
        typeSelect: null,
        levelSelect: null,
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
            // console.log(this.queryParam.codeAndName)
            // console.log(this.queryParam.username)
          if (this.queryParam.createTime !== undefined && this.queryParam.createTime.length > 1) {
            this.queryParam['startTime'] = formatDate(new Date(this.queryParam.createTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['endTime'] = formatDate(new Date(this.queryParam.createTime[1]), 'yyyy-MM-dd hh:mm:ss')
          }
          console.log("查询参数:"+this.queryParam.pageSize);
          return corpBusinessPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              setTimeout(() => {
                $('.blacktr').parents('tr').css("background-color", "#ddd")
              }, 1000);
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],

        options: {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created () {
      this.checkButtonPrivilege()
      this.tableOption()
      this.loadUserSelect()
      this.roleId = this.$store.getters.roles
    },
    mounted() {
      // setTimeout(() => {
      //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
      // }, 1000);
    },
    methods: {
       //分配物流记录按钮权限
     checkButtonPrivilege(record) {

         new Promise(resolve => {
          const data = findPrivileBycode({ code:'shouxin-open' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {

          if(res=='shouxin-open'){
            this.rolelimit=true
          }
          console.log(" this.rolelimit:"+ this.rolelimit)
        })
         new Promise(resolve => {
          const data = findPrivileBycode({ code:'whbi-handler' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {

          if(res=='whbi-handler'){
            this.rolelimitwhbi=true
          }
          console.log(" this.rolelimitwhbi"+ this.rolelimitwhbi)
        })
         new Promise(resolve => {
          const data = findPrivileBycode({ code:'whbl-handler' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {

          if(res=='whbl-handler'){
            this.rolelimitwhbl=true
          }
           console.log(" this.rolelimitwhbl"+ this.rolelimitwhbl)
        })
         new Promise(resolve => {
          const data = findPrivileBycode({ code:'whbd-handler' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {

          if(res=='whbd-handler'){
            this.rolelimitwhbd=true
          }
           console.log(" this.rolelimitwhbd"+ this.rolelimitwhbd)
        })

      },
      moment,
      disabledDate(current) {
        return current && current > moment().endOf('day')
      },
      doReceipt(record) {

         new Promise(resolve => {
          const data = findPrivileBycode({ code:'shouxin-open' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {

          if(res=='shouxin-open'){
            this.rolelimit=true
          }
        })
        this.receiptMdl = {receiptAmount: this.defaultAmount, businessName:record.name,  businessId:record.id, receiptTime: this.defaultDate}
        this.receiptForm = this.$form.createForm(this)
        this.receiptVisible = true
      },
      saveReceipt() {
        this.receiptForm.validateFields((err, values) => {
          if (!err) {
            Object.assign(this.receiptMdl, values)
            this.showLoading = true
            saveReceipt(Object.assign({}, this.receiptMdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.receiptVisible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(res => {
                this.showLoading = false
              })
          }
        })
      },
      validatePhoneBlur(e) {
        const validatePhoneReg = /^1[3456789]\d{9}$/
        if (e.target.value && !validatePhoneReg.test(e.target.value)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'linkManPhone',
          }]
          this.form.setFields({ linkManPhone: { value: e.target.value, errors: arr } })
        }
      },
      getUserNameById(userId){
        if (!userId) return "";
        let result = this.userSelect.map((user, i) => {
          if (userId === user.id){
            return user.username
          }
        })
        return result;
      },
      loadUserSelect () { // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = userList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.userSelect = res
        })
        this.typeSelect = this.$store.getters.codeList.basic_black_list_type
        this.levelSelect = this.$store.getters.codeList.basic_corp_level
      },
      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      tableOption () {
        if (!this.optionAlertShow) {
          this.options = {
            alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },

      handleEdit (record) {

        this.mdl = Object.assign({}, record)
        this.mdl.validPeriod=moment(new Date(this.mdl.validPeriod), 'YYYY-MM-DD')
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },

      handleAdd () {
        this.mdl = {}
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },
      handleOk () {

        // 手机号验证
        var linkManPhone=this.mdl.linkManPhone
        const validatePhoneReg = /^1[3456789]\d{9}$/
        if (linkManPhone && !validatePhoneReg.test(linkManPhone)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'linkManPhone',
          }]
          this.form.setFields({ linkManPhone: { value: linkManPhone, errors: arr } })
          return
        }
       /* var phone=this.mdl.phone
        if (phone && !validatePhoneReg.test(phone)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'phone',
          }]
          this.form.setFields({ phone: { value: phone, errors: arr } })
          return
        }*/
        this.form.validateFields((err, values) => {
          Object.assign(this.mdl, values)
          if (!err) {
            this.confirmLoading = true
            if (this.mdl.id !== undefined) {
              corpBusinessUpdate(Object.assign({}, this.mdl))
                .then(res => {
                  if (res.code === '0') {
                    this.$refs.table.refresh()
                    this.visible = false
                  }
                }).catch((e) => {
                  console.log(e)
                }).finally(() => {
                  this.confirmLoading = false
                })
            } else {
              corpBusinessSave(Object.assign({}, this.mdl))
                .then(res => {
                  if (res.code === '0') {
                    this.$refs.table.refresh()
                    this.visible = false
                  }
                }).catch((e) => {
                  console.log(e)
                }).finally(() => {
                  this.confirmLoading = false
                })
            }
          }
        })
      },

      handleBlack (record) {
        this.black["type"] = '2'
        this.black["name"] = record.name
        this.black["recordId"] = record.id
        this.black["remark"] = ''
        this.form = this.$form.createForm(this)
        this.blackModel = true
      },

      handleBlackOk ({ commit }) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            blackListSave(Object.assign({}, this.black))
              .then(res => {
                if (res.code === '0') {
                  let blackList = this.$store.getters.blackList
                  if (!blackList['2'])
                    blackList['2'] = {}
                  blackList['2'][this.black.recordId] = this.black
                  this.$store.commit('SET_BLACK', blackList)
                  this.$refs.table.refresh()
                  this.blackModel = false
                  // this.$refs.table.refresh(true)
                  // setTimeout(() => {
                  //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
                  // }, 1000);
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          }
        })
      },

      handleDel (record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            nthis.confirmLoading = true
            return corpBusinessDelete(Object.assign(record, nthis.queryParam))
              .then(res => {
                if (res.code === '0') {
                  nthis.$refs.table.refresh()
                }
              }).catch((e) => {
                console.log(e)
              })
          },
          onCancel () {
          }
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      handleChange (info) {
        if (info.file.status === 'uploading') {
          Bus.$emit('showSpinning', true, "准备导入...")
        }

        if (info.file.status === 'done') {
          Bus.$emit('showSpinning', false)
          if (info.file.response && info.file.response.code === '0'){
            this.$message.success('导入成功！')
            this.$refs.table.refresh()
          }else{
            this.$message.error(info.file.response.message)
          }
        }
      },
      beforeUpload (file) {

      },
      downLoad(){
        let url=this.config.downLoadMouldUrl+"客户.xlsx"
        window.location.href=url
      },
      OneclickExemption() {
          var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要一键免审吗?',
          onOk () {
            nthis.confirmLoading = true
            return updateFromAudit()
              .then(res => {
                if (res.code === '0') {
                  nthis.$refs.table.refresh()
                }
              }).catch((e) => {
                console.log(e)
              })
          },
          onCancel () {
          }
        })
      },

      handleExport() {
        var codeAndName=this.queryParam.codeAndName
        var username=this.queryParam.username
        if(!codeAndName){
          codeAndName=''
        }
        if(!username){
          username=''
        }
        const token = Vue.ls.get(ACCESS_TOKEN)
        window.location.href = this.config.downloadCorpBusinessUrl + '&accessToken=' + token +'&codeAndName=' +codeAndName +'&username=' +username
      },
    },
    watch: {

    },

  }

</script>
